module.exports = __webpack_public_path__ + "pw.875ce4a918d138bec98e.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/GKool/source/repos/e2epublicwebsite/src/assets/vendors/flag-icon/flags/1x1/pw.svg
// module id = ../../../../../src/assets/vendors/flag-icon/flags/1x1/pw.svg
// module chunks = 0